import { mount, ReactWrapper } from 'enzyme';
import moment from 'moment';
import type { FilterOption } from '../components/downloads/Filter.d';
import type { ECountry } from './constants';
import { COUNTRIES, REPORT_LANGUAGE_EN, REPORT_LANGUAGES, REPORT_LANGUAGES_BY_COUNTRY } from './constants';

// Should use Suspense integrations like Relay
export function wrapPromise<T>(promise: Promise<T>): { read(): T | undefined } {
  let status = 'pending';
  let result: T;
  const suspender = promise.then(
    (r) => {
      status = 'success';
      result = r;
    },
    (e) => {
      status = 'error';
      result = e;
    }
  );
  return {
    read() {
      switch (status) {
        case 'pending':
          throw suspender;
        case 'error':
          // console.assert(false);
          throw result;
        case 'success':
          return result;
      }
    },
  };
}

interface IOptionDatum {
  children: string;
  key: string;
  value: string;
}

// Panic if select does not have popupElement
export function getJestWrapperOptions(select: ReactWrapper): IOptionDatum[] {
  return mount(
    select
      .findWhere((node) => node.prop('popupElement'))
      .first()
      .prop('popupElement')
  ).prop('options');
}

export const generateMonthList = (earliestMonth: string, latestMonth?: string): FilterOption[] => {
  const currentDate = moment(latestMonth);

  const monthList = [
    {
      label: 'All months',
      value: 'all',
    },
  ];

  while (currentDate.isAfter(moment(earliestMonth)) && currentDate.diff(moment(earliestMonth), 'month') >= 0) {
    monthList.push({
      label: currentDate.format('MMM YYYY'),
      value: currentDate.format('YYYY-MM'),
    });
    currentDate.subtract(1, 'month');
  }

  return monthList;
};

export const isSingapore = process.env.REACT_APP_REGION === COUNTRIES.SG;
export const isMalaysia = process.env.REACT_APP_REGION === COUNTRIES.MY;
export const isAustralia = process.env.REACT_APP_REGION === COUNTRIES.AU;
export const isHongKong = process.env.REACT_APP_REGION === COUNTRIES.HK;

// Report language options available for the current region, in catalog order.
// Regions without an explicit entry only offer English.
export const getReportLanguages = () => {
  const region = process.env.REACT_APP_REGION as ECountry;
  const availableValues = REPORT_LANGUAGES_BY_COUNTRY[region] ?? [REPORT_LANGUAGE_EN];
  return REPORT_LANGUAGES.filter((language) => availableValues.includes(language.value));
};
